import { API_URL } from '../../../app-config/constants';
import { Answer, CycleFeedbackAnswer } from '../../../types/FeedbackQuestionnaire';
import { CycleFeedbackResponseDto } from '../../../types/FeedbackResponseDto';
import { get as httpGet, post } from '../request';

const BASE_URL = `${API_URL}/cycle-feedback-response`;

const toUrl = (responseId: string) => `${BASE_URL}/${responseId}`;

const executeCommand = (responseId: string, command: string, postData?: any): Promise<CycleFeedbackResponseDto> =>
    post(`${toUrl(responseId)}/${command}`, { postData });

get.operation = 'READ';
export function get(responseId: string): Promise<CycleFeedbackResponseDto> {
    return httpGet(toUrl(responseId));
}

share.operation = 'COMMAND';
export function share(responseId: string): Promise<CycleFeedbackResponseDto> {
    return executeCommand(responseId, 'share');
}

reopen.operation = 'COMMAND';
export function reopen(responseId: string): Promise<CycleFeedbackResponseDto> {
    return executeCommand(responseId, 'reopen');
}

decline.operation = 'COMMAND';
export function decline(responseId: string): Promise<CycleFeedbackResponseDto> {
    return executeCommand(responseId, 'decline');
}

answer.operation = 'COMMAND';
export function answer(
    responseId: string,
    answers: Answer[] | CycleFeedbackAnswer[]
): Promise<CycleFeedbackResponseDto> {
    return executeCommand(responseId, 'answer', answers);
}
